import React from "react";
import { STATE_KEYS } from "utils/constants/state";
import get from "lodash/get";
import startCase from "lodash/startCase";
import { useFormikContext } from "formik";
import { PAYMENT_MODE, PAYMENT_MODE_COPY } from "utils/constants/payment";
import Toggle from "react-toggle";
import { getToggleProps } from "utils/form";
import ExternalLink from "components/ExternalLink";
import { STRIPE_DOCS_LINKS } from "utils/constants/stripe";
import { useShortLinkMode } from "utils/hooks/shortLink";
import InheritenceDisplay from "components/InheritenceDisplay";
import classnames from "classnames";

const DEFAULT_TITLE = "Setup mode";
const SetupMode = ({ name, inherited, title } = { title: DEFAULT_TITLE }) => {
  const ctxTitle = title || DEFAULT_TITLE;
  const { touched, setFieldValue, setFieldTouched } = useFormikContext();

  const {
    error,
    isSetupMode,
    inheritedMode,
    activeInheritence,
    disabledMode
  } = useShortLinkMode({
    inherited
  });

  if (activeInheritence) {
    return (
      <InheritenceDisplay
        error={error}
        title={ctxTitle}
        onRemove={() => {
          setFieldValue(STATE_KEYS.SHORT_LINK.MODE, null);
        }}
      >
        <div className="flex flex-row justify-between items-center pt3">
          <div className="f6 word-break">{startCase(inheritedMode)}</div>
        </div>
      </InheritenceDisplay>
    );
  } else {
    return (
      <div className="flex flex-column w-100">
        <div className="flex flex-row items-center justify-between">
          <label
            className={classnames("f5 fw6 db", {
              "color-error": error
            })}
          >
            {ctxTitle}
          </label>
          <Toggle
            {...getToggleProps({
              active: isSetupMode,
              disabled: disabledMode,
              setFieldValue: (_, active) => {
                if (!get(touched, STATE_KEYS.SHORT_LINK.MODE)) {
                  setFieldTouched(STATE_KEYS.SHORT_LINK.MODE, true);
                }

                setTimeout(() => {
                  setFieldValue(
                    STATE_KEYS.SHORT_LINK.MODE,
                    isSetupMode ? null : PAYMENT_MODE.SETUP
                  );
                }, 0);
              }
            })}
          />
        </div>
        <div className="f6 pt2 lh-copy">{PAYMENT_MODE_COPY.INFO}</div>
        <div className="flex flex-column pt2">
          <div className="pt2">
            <ExternalLink
              href={STRIPE_DOCS_LINKS.PAYMENT_METHOD_SETUP}
              copy="Learn more"
              customClasses={{
                container: "w-100 db",
                link:
                  "link flex flex-row items-center link__decoration--hover color-primary pointer w-100 word-break-all",
                copy: "f6 fw6 lh-title pr1"
              }}
            />
          </div>
        </div>
      </div>
    );
  }
};
export default SetupMode;
